// src/pages/NotFound.js

import React from "react";
import styles from "./NotFound.module.css"; // Import NotFound CSS Module

function NotFound() {
  return (
    <div className={styles.notFoundContainer}>
      <h2>404 - Page Not Found</h2>
      <p>Sorry, the page you're looking for doesn't exist or is currently under development.</p>
      <a href="/" className={styles.goBackButton}>Go Back Home</a>
    </div>
  );
}

export default NotFound;
